import Swiper from "swiper";
import { Pagination, Navigation, Autoplay, FreeMode } from "swiper/modules";

import GLightbox from "glightbox";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

/* EXPAND TO FULLWIDTH */
const element = document.querySelector(".expand-fullwidth");

if (element) {
  // Assicurati di ottenere le dimensioni originali prima di qualsiasi manipolazione
  // Memorizza i valori come stringhe con le unità di misura
  const originalStyles = {
    maxWidth: getComputedStyle(element).maxWidth,
    minHeight: getComputedStyle(element).minHeight,
    borderRadius: getComputedStyle(element).borderRadius,
  };

  // Converti solo per debug/log
  const originalMaxWidth = parseFloat(originalStyles.maxWidth);
  const originalMinHeight = parseFloat(originalStyles.minHeight);

  const fullWidth = window.innerWidth;
  const fullHeight = window.innerHeight;

  // Prima animazione: da originale a pieno schermo
  const tl1 = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: "top bottom",
      end: "top top",
      scrub: true,
      id: "expandAnimation",
    },
  });

  tl1.fromTo(
    element,
    {
      maxWidth: originalStyles.maxWidth,
      minHeight: originalStyles.minHeight,
      borderRadius: originalStyles.borderRadius,
    },
    {
      maxWidth: fullWidth + "px",
      minHeight: fullHeight + "px",
      borderRadius: "0px",
      ease: "none",
    },
  );

  // Seconda animazione: da pieno schermo a originale
  const tl2 = gsap.timeline({
    scrollTrigger: {
      trigger: element,
      start: "top+=20 top",
      end: "bottom top",
      scrub: true,
      id: "contractAnimation",
    },
  });

  tl2.fromTo(
    element,
    {
      maxWidth: fullWidth + "px",
      minHeight: fullHeight + "px",
      borderRadius: "0px",
    },
    {
      maxWidth: originalStyles.maxWidth,
      minHeight: originalStyles.minHeight,
      borderRadius: originalStyles.borderRadius,
      ease: "none",
    },
  );
}

/* END EXPAND TO FULLWIDTH */

/* SLIDE IN TOP */
const slideInTopEls = document.querySelectorAll(".slide-in-top");
if (slideInTopEls.length) {
  gsap.from(slideInTopEls, {
    y: "-200%",
    duration: 1,
    ease: "power2.out",
  });
}

/* END SLIDE IN TOP */

/* SLIDE IN LEFT */
const slideInLeftEls = document.querySelectorAll(".slide-in-left");
if (slideInLeftEls.length) {
  gsap.from(slideInLeftEls, {
    x: "-100%",
    duration: 1,
    ease: "power2.out",
  });
}

/* END SLIDE IN LEFT */

/*SLIDE PANEL*/
const pinnedPanels = gsap.utils.toArray(".pinned");

// Trova l'ultimo pannello pinnato
const lastPinnedPanel = pinnedPanels[pinnedPanels.length - 1];

if (lastPinnedPanel) {
  // Usa il primo elemento successivo come trigger di fine
  const endTriggerElement = lastPinnedPanel.nextElementSibling || document.body;

  pinnedPanels.forEach((panel, i) => {
    ScrollTrigger.create({
      trigger: panel,
      start: "top top",
      endTrigger: endTriggerElement,
      end: "top top",
      pin: true,
      pinSpacing: false,
      id: i + 1,
    });
  });
}

/*END SLIDE PANEL*/

/*Anchor to left*/
gsap.matchMedia().add("(min-width: 768px)", () => {
  // Tutto il codice dell'animazione qui dentro
  // Verrà eseguito solo se la viewport è >= 768px (desktop/tablet)
  const floatingEl = document.getElementById("floatingEl");

  if (!floatingEl) {
    return; // Interrompe l'esecuzione della funzione
  }

  let isAtFinalPosition = false;
  let pinnedRect = null;
  let finalX = 0;

  const animation = gsap.to(floatingEl, {
    scrollTrigger: {
      trigger: floatingEl,
      start: "top top",
      end: "+=400",
      scrub: true,
      onEnter: () => {
        pinnedRect = floatingEl.getBoundingClientRect();
        floatingEl.style.position = "fixed";
        floatingEl.style.top = pinnedRect.top + "px";
        floatingEl.style.left = pinnedRect.left + "px";
        floatingEl.style.width = pinnedRect.width + "px";
        floatingEl.style.zIndex = "30";
        floatingEl.style.cursor = "pointer";
        finalX = -(pinnedRect.right - 20);
      },
      onUpdate: (self) => {
        isAtFinalPosition = self.progress >= 1;
      },
      onLeaveBack: () => {
        floatingEl.style.position = "";
        floatingEl.style.top = "";
        floatingEl.style.left = "";
        floatingEl.style.width = "";
        floatingEl.style.zIndex = "";
        floatingEl.style.cursor = "";
        isAtFinalPosition = false;
        pinnedRect = null;
        finalX = 0;
      },
    },
    x: () =>
      pinnedRect ? finalX : -(floatingEl.getBoundingClientRect().right - 20),
    y: () => window.innerHeight / 2 - floatingEl.offsetHeight / 2,
    ease: "power2.inOut",
  });

  floatingEl.addEventListener("mouseenter", () => {
    if (!isAtFinalPosition || !pinnedRect) return;
    gsap.to(floatingEl, {
      x: -pinnedRect.left,
      duration: 0.35,
      ease: "power2.out",
      overwrite: "auto",
    });
  });
  floatingEl.addEventListener("mouseleave", () => {
    if (!isAtFinalPosition || !pinnedRect) return;
    gsap.to(floatingEl, {
      x: finalX,
      duration: 0.35,
      ease: "power2.in",
      overwrite: "auto",
    });
  });

  window.addEventListener("resize", () => {
    if (pinnedRect) {
      pinnedRect = floatingEl.getBoundingClientRect();
      floatingEl.style.left = pinnedRect.left + "px";
      floatingEl.style.top = pinnedRect.top + "px";
      floatingEl.style.width = pinnedRect.width + "px";
      finalX = -(pinnedRect.right - 20);
    }
    ScrollTrigger.refresh();
  });
});

/*End Anchor to left*/

/*LIGHTBOX*/
const lightbox = GLightbox({
  selector: ".glightbox",
  touchNavigation: true,
});
/*END LIGHTBOX*/

/*SLIDESHOW*/
const slideShow = new Swiper(".slideShow", {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 10,
  breakpoints: {
    // when window width is >= 768px
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
/*END SLIDESHOW*/

/*SLIDESHOW APP*/
const slideShowApp = new Swiper(".slideShowApp", {
  modules: [Pagination],
  slidesPerView: 1,
  spaceBetween: 10,
  breakpoints: {
    // when window width is >= 768px
    768: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
/*END SLIDESHOW APP*/

/*GALLERY*/
const gallery = new Swiper(".gallery", {
  modules: [Navigation],
  slidesPerView: 1,
  spaceBetween: 24,
  breakpoints: {
    // when window width is >= 768px
    768: {
      slidesPerView: 2,
      spaceBetween: 24,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
/*END GALLERY*/

/*CAROUSEL PLACES*/
const carousel = new Swiper(".carouselPlaces", {
  // Default parameters
  slidesPerView: 1.2,
  spaceBetween: 20,
  breakpoints: {
    // when window width is >= 768px
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
  },
});
/*END CAROUSEL PLACES*/

/*MENU*/
document.addEventListener("DOMContentLoaded", function () {
  const nav = document.querySelector(".wp-block-navigation");
  const burgerBtn = nav?.querySelector(
    ".wp-block-navigation__responsive-container-open",
  );
  const container = nav?.querySelector(
    ".wp-block-navigation__responsive-container",
  );
  const submenuItems = nav?.querySelectorAll("li.wp-block-navigation-submenu");
  const header = document.querySelector("header");
  const BREAKPOINT = 1024;

  const isMobile = () => window.innerWidth < BREAKPOINT;

  // Toggle apertura menu mobile
  if (burgerBtn && container) {
    burgerBtn.addEventListener("click", () => {
      container.classList.toggle("is-menu-open");
      header.classList.toggle("is-menu-open");
    });
  }

  // Toggle sottomenù su mobile
  submenuItems?.forEach((item) => {
    item.addEventListener("click", (e) => {
      if (!isMobile()) return;

      // Evita che il click sul link provochi il redirect immediato
      const link = item.querySelector("a.wp-block-navigation-item__content");
      if (link && link.contains(e.target)) {
        e.preventDefault();
      }

      // Evita che l’evento propaghi in profondità
      e.stopPropagation();

      const isOpen = item.classList.contains("is-submenu-open");

      // Chiudi tutti gli altri sottomenu (opzionale)
      document
        .querySelectorAll("li.wp-block-navigation-submenu.is-submenu-open")
        .forEach((el) => {
          if (el !== item) el.classList.remove("is-submenu-open");
        });

      // Toggle attuale
      item.classList.toggle("is-submenu-open", !isOpen);
    });
  });

  // Sposta il menu fuori dall'header su mobile
  const relocateResponsiveContainer = () => {
    if (!container || !header) return;

    if (isMobile()) {
      if (container.parentNode !== document.body) {
        document.body.appendChild(container);
      }
    } else {
      if (container.parentNode !== nav) {
        nav.appendChild(container);
      }
    }
  };

  relocateResponsiveContainer(); // Chiamata iniziale
  window.addEventListener("resize", () => {
    relocateResponsiveContainer();

    // Chiudi menu se si passa a desktop
    if (!isMobile() && container?.classList.contains("is-menu-open")) {
      container.classList.remove("is-menu-open");
    }
  });
});

/*END MENU*/

/*Marquee*/

document.addEventListener("DOMContentLoaded", function () {
  const marquees = document.querySelectorAll(".marquee");
  if (!marquees.length) return;

  marquees.forEach((marquee) => {
    const duration = parseInt(marquee.getAttribute("duration"), 10) || 20;
    const marqueeContent = marquee.querySelector(".marquee-content");
    if (!marqueeContent || !(marqueeContent instanceof Element)) return;

    const marqueeContentClone = marqueeContent.cloneNode(true);
    marquee.append(marqueeContentClone);

    let tween;

    const playMarquee = () => {
      let progress = tween ? tween.progress() : 0;
      tween && tween.progress(0).kill();

      const width = marqueeContent.offsetWidth;
      const style = getComputedStyle(marqueeContent);
      const gap = parseInt(style.columnGap || style.gap || 0, 10);
      const distanceToTranslate = -1 * (gap + width);

      tween = gsap.fromTo(
        marquee.children,
        { x: 0 },
        { x: distanceToTranslate, duration, ease: "none", repeat: -1 },
      );
      tween.progress(progress);
    };

    playMarquee();

    // Resize listener per questo specifico marquee
    window.addEventListener("resize", debounce(playMarquee));
  });

  // Debounce globale
  function debounce(func, wait = 500) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func.apply(this, args), wait);
    };
  }
});

/*FOOTER MENU DETAILS*/
function toggleDetailsOpen() {
  const detailsElements = document.querySelectorAll(
    "details.is-style-menu_footer",
  );
  const isMobile = window.innerWidth < 1024;

  detailsElements.forEach((el) => {
    if (isMobile) {
      el.removeAttribute("open");
    } else {
      el.setAttribute("open", "");
    }
  });
}

// Esegui al load
window.addEventListener("DOMContentLoaded", toggleDetailsOpen);

// Esegui al resize
window.addEventListener("resize", toggleDetailsOpen);
/*END FOOTER MENU DETAILS*/

/*TABS APP*/
const tabsApp = new Swiper(".tabsApp", {
  modules: [Pagination],
  slidesPerView: 1,
  spaceBetween: 20,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  on: {
    slideChange: function () {
      updateTabsState(this);
    },
  },
});

document.addEventListener("DOMContentLoaded", function () {
  const tabsApps = document.querySelectorAll(".tabsApp");

  tabsApps.forEach(function (tabsApp) {
    const swiperWrapper = tabsApp.querySelector(".swiper-wrapper");
    const tabsContainer = tabsApp.querySelector(".tabs");

    if (!swiperWrapper || !tabsContainer) return;

    // Nascondi il container per prevenire layout shift
    tabsApp.style.visibility = "hidden";

    // Trova tutti gli slide (Swiper usa .swiper-slide)
    const slides = swiperWrapper.querySelectorAll(".swiper-slide");

    // Trova l'istanza Swiper associata a questo tabsApp
    const swiper = tabsApp.swiper;

    slides.forEach(function (slide, index) {
      // Cerca l'elemento .tab dentro ogni slide
      const tabElement = slide.querySelector(".tab");

      if (tabElement) {
        // Clona l'elemento .tab
        const clonedTab = tabElement.cloneNode(true);

        // Verifica se la slide non è attiva
        if (!slide.classList.contains("swiper-slide-active")) {
          clonedTab.classList.add("tab-inactive");
        }

        // Aggiungi evento onclick al tab clonato
        clonedTab.addEventListener("click", function () {
          if (swiper) {
            swiper.slideTo(index);
          }
        });

        // Aggiungi il tab clonato al container .tabs
        tabsContainer.appendChild(clonedTab);
      }
    });

    // Mostra il container dopo aver completato l'elaborazione
    tabsApp.style.visibility = "visible";
  });
});

// Funzione per aggiornare lo stato dei tab
function updateTabsState(swiper) {
  const tabsContainer = swiper.el.querySelector(".tabs");
  if (!tabsContainer) return;

  const clonedTabs = tabsContainer.querySelectorAll(".tab");

  clonedTabs.forEach(function (tab, index) {
    // Controlla se questo tab corrisponde alla slide attiva
    if (index === swiper.activeIndex) {
      // Tab attivo: rimuovi classe inactive
      tab.classList.remove("tab-inactive");
    } else {
      // Tab inattivo: aggiungi classe inactive
      tab.classList.add("tab-inactive");
    }
  });
}
/*END TABSAPP*/

/*FORMINATOR*/
jQuery(document).ready(function ($) {
  const fieldGroups = document.querySelectorAll(".forminator-field-group");

  if (!fieldGroups.length) return;

  fieldGroups.forEach((group) => {
    const fieldWrappers = Array.from(
      group.querySelectorAll(".forminator-field"),
    ).filter((wrapper) => {
      const field = wrapper.querySelector("input, textarea, select");
      const isRepeaterButton = wrapper.querySelector(
        ".forminator-repeater-action-button",
      );
      return field && !isRepeaterButton;
    });

    if (!fieldWrappers.length) return;

    const checkGroupStatus = () => {
      const allFilled = fieldWrappers.every((wrapper) => {
        const field = wrapper.querySelector("input, textarea, select");
        return wrapper.classList.contains("forminator-is_filled");
      });

      group.classList.toggle("all-fields-filled", allFilled);
    };

    fieldWrappers.forEach((wrapper) => {
      const field = wrapper.querySelector("input, textarea, select");

      if (
        field &&
        field.tagName === "SELECT" &&
        field.classList.contains("forminator-select2")
      ) {
        $(field).on("change", function () {
          const selectedValue = $(this).val();
          const placeholder =
            field.getAttribute("data-placeholder")?.trim() || "";

          if (
            selectedValue &&
            selectedValue !== "" &&
            selectedValue !== placeholder
          ) {
            wrapper.classList.add("forminator-is_filled");
          } else {
            wrapper.classList.remove("forminator-is_filled");
          }

          checkGroupStatus();
        });
      } else if (field) {
        ["input", "change", "blur"].forEach((evt) => {
          field.addEventListener(evt, function () {
            if (field.value && field.value.trim() !== "") {
              wrapper.classList.add("forminator-is_filled");
            } else {
              wrapper.classList.remove("forminator-is_filled");
            }
            checkGroupStatus();
          });
        });
      }
    });

    checkGroupStatus(); // controllo iniziale
  });
});

/*END FORMINATOR*/

/*SELECTOR PREZZI*/
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".eleven-prezzi").forEach((widget) => {
    const dropdown = widget.querySelector(".dropdown");
    const trigger = widget.querySelector(".dropdown-trigger");
    const menu = widget.querySelector(".dropdown-menu");
    const label = widget.querySelector(".label");
    const valueBox = widget.querySelector(".value-box");
    const options = widget.querySelectorAll(".dropdown-option");

    function openMenu() {
      dropdown.classList.add("open");
    }

    function closeMenu() {
      dropdown.classList.remove("open");
    }

    function selectOption(btn) {
      options.forEach((o) => o.classList.remove("selected"));
      btn.classList.add("selected");

      label.textContent = btn.dataset.value;
      valueBox.innerHTML = `${btn.dataset.price}`;

      closeMenu();
    }

    trigger.addEventListener("click", () => {
      dropdown.classList.contains("open") ? closeMenu() : openMenu();
    });

    options.forEach((btn) => {
      btn.addEventListener("click", () => selectOption(btn));
    });
  });
});
/*END SELECTOR PREZZI*/
